import { extractErrorMessage } from './apiError';

/**
 * Состояния UI Web Push (ТЗ Part 2, 9.1) плюс седьмое, служебное:
 * UNAUTHORIZED. Оно нужно потому, что GET /web-push/public-key отвечает 401
 * неавторизованному пользователю, а ТЗ 11.5 прямо запрещает считать это
 * недоступностью Web Push.
 */
export const WEB_PUSH_STATE = {
  UNSUPPORTED: 'unsupported',
  UNAUTHORIZED: 'unauthorized',
  BACKEND_UNAVAILABLE: 'backend_unavailable',
  PERMISSION_DENIED: 'permission_denied',
  PERMISSION_DEFAULT: 'permission_default',
  NOT_SUBSCRIBED: 'not_subscribed',
  SUBSCRIBED: 'subscribed',
};

export const deriveWebPushState = ({ supported, permission, backend, subscribed }) => {
  if (!supported) return WEB_PUSH_STATE.UNSUPPORTED;
  if (backend === 'unauthorized') return WEB_PUSH_STATE.UNAUTHORIZED;
  if (backend === 'unavailable') return WEB_PUSH_STATE.BACKEND_UNAVAILABLE;
  if (permission === 'denied') return WEB_PUSH_STATE.PERMISSION_DENIED;
  if (permission === 'default') return WEB_PUSH_STATE.PERMISSION_DEFAULT;
  // granted: подписка засчитывается только после успешной регистрации в backend.
  return subscribed ? WEB_PUSH_STATE.SUBSCRIBED : WEB_PUSH_STATE.NOT_SUBSCRIBED;
};

export const mapPublicKeyError = (error) =>
  (error?.response?.status === 401 ? 'unauthorized' : 'unavailable');

export const describeSubscribeError = (error) => {
  const status = error?.response?.status;
  if (status === 409) return 'Это устройство уже привязано к другому аккаунту';
  if (status === 422) return 'Браузер вернул некорректную подписку. Попробуйте ещё раз';
  return extractErrorMessage(error, 'Не удалось включить уведомления');
};

/** VAPID-ключ приходит в base64url, а pushManager.subscribe ждёт Uint8Array. */
export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
};
